import React from 'react'
import LoggedOutLayoutContainer from './LoggedOutLayoutContainer'

const LoggedOutLayout = (props) => (
  <LoggedOutLayoutContainer {...props} />
)

export default LoggedOutLayout



// WEBPACK FOOTER //
// src/layouts/LoggedOut/index.js